/**
 * La versión vigente de los términos y la privacidad (CUENTAS-01/ADMIN-02). Vive aquí, y no solo
 * en `apps/web`, porque los dos lados la necesitan: la web para mostrar los textos y guardar la
 * versión que se acepta, y el API para comparar la versión que aceptó cada cuenta con la vigente
 * y decidir si hace falta pedir un reconsentimiento (`plan/decisiones.md`, 2026-09-28).
 *
 * Los textos en sí (`PRIVACIDAD`, `TERMINOS`) siguen solo en la web: son contenido de presentación,
 * no un contrato entre los dos lados. Solo la versión, un identificador, se comparte.
 */
export const VERSION_TERMINOS = '2026-10-01';
//# sourceMappingURL=legal.js.map